<template>
  <div class="offer-container">
    <div class="results-wrapper">
      <div class="form-flex">
        <div class="results-header-container">
          <v-breadcrumbs :items="bread" divider=">"></v-breadcrumbs>
          <div class="results-header">
            <h3>Substations & Lines</h3><br>
          </div>

          <!-- <div class="matching-button-wrapper">
            <v-btn depressed tile color="#58c26d" class="match-button2">
              Show offers
            </v-btn>
            <v-btn outline depressed class="match-button">
              Show requests
            </v-btn>
          </div> -->

          <div class="match-header">
            <div class="form-flex">
              <div class="column1">Type of substations</div>
              <div class="column2">
                <v-select
                  v-model="selectedKV"
                  class="filter-input2" 
                  hide-details
                  color="#58c26d"
                  @change="changeKV()"
                  :items="kVs"
                  item-text="kVName"
                  item-value="kVCode"
                  dense
                  outlined
                ></v-select>
              </div>
            </div>
          </div>

          <div class="legend">

            <div>
              <svg height="20" width="20">
                <circle cx="10" cy="10" r="7" stroke="#00FF00" stroke-width="3" fill="#000000" />
              </svg>
              <svg height="30" width="380">
                <text x="20" y="25">154 kV SUBSTATIONS</text>
              </svg>

              <svg height="10" width="50">
                <line x1="0" y1="0" x2="50" y2="0" style="stroke:rgb(0,255,0);stroke-width:5" />
              </svg>
              <svg height="30" width="225">
                <text x="20" y="25">154 kV OHL</text>
              </svg>

            </div>

            <div>
              <svg height="20" width="20">
                <circle cx="10" cy="10" r="7" stroke="#FF0000" stroke-width="3" fill="#FFCCCB" />
              </svg>
              <svg height="30" width="380">
                <text x="20" y="25">400 kV SUBSTATIONS</text>
              </svg>

              <svg height="10" width="50">
                <line x1="0" y1="0" x2="50" y2="0" style="stroke:rgb(255,0,0);stroke-width:5" />
              </svg>
              <svg height="30" width="225">
                <text x="20" y="25">400 kV OHL</text>
              </svg>
            </div>

            <div v-if="!loadedState">

              <svg height="20" width="20">
                <circle cx="10" cy="10" r="7" stroke="#000000" stroke-width="3" fill="#7DF9FF" />
              </svg>
              <svg height="30" width="380">
                <text x="20" y="25">20 kV SUBSTATIONS</text>
              </svg>

              <svg height="20" width="50">
                <g fill="none">
                  <path stroke="red" d="M5 7 l50 0" />
                  <path stroke="red" d="M5 10 l50 0" />
                </g>
              </svg>
              <svg height="30" width="200">
                <text x="20" y="25">20 kV Lines</text>
              </svg>

            </div>

            <div v-if="!loadedState">

              <svg height="20" width="20">
                <circle cx="10" cy="10" r="7" stroke="#000000" stroke-width="3" fill="#B42222" />
              </svg>
              <svg height="30" width="380">
                <text x="20" y="25">10 kV SUBSTATIONS</text>
              </svg>

              <svg height="20" width="50">
                <g fill="none">
                  <path stroke="#696969" d="M5 7 l50 0" />
                  <path stroke="#696969" d="M5 10 l50 0" />
                </g>
              </svg>
              <svg height="30" width="200">
                <text x="20" y="25">10 kV Lines</text>
              </svg>
              
            </div>

            <br>

            <div class="form-flex">
              <div class="column1">
                <div class="key-container">
                    <div class="label-container">
                        <div class="loadMarker"></div>
                        <label for="green">Load</label>
                    </div>
                    <div class="label-container">
                        <div class="evMarker "></div>
                        <label for="yellow">EV</label>
                    </div>
                    <div class="label-container">
                        <div class="generationMarker"></div>
                        <label for="red">Generation</label>
                    </div>
                </div>
              </div>

              <div class="column2">
                <div class="key-container">
                    <div class="label-container">
                        <div class="color green"></div>
                        <label for="green">0 to 10 MW</label>
                    </div>
                    <div class="label-container">
                        <div class="color yellow"></div>
                        <label for="yellow">10 to 50 MW</label>
                    </div>
                    <div class="label-container">
                        <div class="color red"></div>
                        <label for="red"> > 50 MW</label>
                    </div>
                </div>
              </div>
            </div>

            <br>

          </div>

          <div class="match-header" v-if="!loadedState">
            <div class="form-flex">
              <div class="column1">List of substations &middot; <span class="match-span"> {{this.stateSubstations.length}} substations</span>
              </div>
              <div class="column2">
                <v-select
                  v-model="selectedStateSubs"
                  class="filter-input2" 
                  hide-details
                  color="#58c26d"
                  @change="changeStateSubs()"
                  :items="stateSubs"
                  item-text="subName"
                  item-value="subCode"
                  dense
                  outlined
                ></v-select>
              </div>
            </div>
          </div>
    
          <div class="table-wrapper thead" v-if="!loadedState">
            <thead>
              <tr>
                <th class="resource-id">No.</th>
                <th class="resource-name">Name</th>
                <th>Operating</th>
                <th>Status</th>
                <th class="resource-coord">Latitude</th>
                <th class="resource-coord">Longitude</th>
              </tr>
            </thead>
          </div>
          <div class="table-wrapper t-bottom" id="offersTable" v-if="!loadedState">
            <tbody :class="{ active: index == currentRequestIndex }"
                    v-for="(stateSubstation, index) in stateSubstations"
                    :key="index"
                    @click="setActiveRequest(stateSubstation, index)">
                <tr>
                    <td class="resource-id">{{ stateSubstation.properties.id }}</td>
                    <td class="resource-name">{{ stateSubstation.properties.name }}</td>
                    <td>{{ stateSubstation.properties.operating }}</td>
                    <td>{{ stateSubstation.properties.status }}</td>
                    <td class="resource-coord">{{ stateSubstation.geometry.coordinates[0] }}</td>
                    <td class="resource-coord">{{ stateSubstation.geometry.coordinates[1] }}</td>
                </tr>
            </tbody>
          </div>

          <br>
          <div class="match-header" v-if="!loadedState">
            List of lines &middot;<span class="match-span">
              {{this.list_State_Lines.length}} lines</span
            >
          </div>
          <div class="table-wrapper thead" v-if="!loadedState">
            <thead>
              <tr>
                <th class="resource-id">No.</th>
                <th class="resource-name">Name</th>
                <th>From</th>
                <th>To</th>
                <th>Operating</th>
                <th>Status</th>
                <th>Impedance (Ohm)</th>
                <th>Distance (km)</th>
              </tr>
            </thead>
          </div>
          <div class="table-wrapper t-bottom" id="offersTable" v-if="!loadedState">
            <tbody>
              <tr :class="{ active: index == currentMatchingIndex }"
                  v-for="(list_State_Line, index) in list_State_Lines"
                  :key="index"
                  @click="setActiveRequest(list_State_Line, index)">
                <td class="resource-id">{{ list_State_Line.properties.id }}</td>
                <td class="resource-name">{{ list_State_Line.properties.name }}</td>
                <td>{{ list_State_Line.properties.from }}</td>
                <td>{{ list_State_Line.properties.to }}</td>
                <td>{{ list_State_Line.properties.operating }}</td>
                <td>{{ list_State_Line.properties.status }}</td>
                <td>{{ list_State_Line.properties.impedance }}</td>
                <td>{{ list_State_Line.properties.distance }}</td>
              </tr>
            </tbody>
          </div>


          <!-- <div class="match-header" v-if="!loadedDSO"> -->
          <div class="match-header">
            <div class="form-flex">
              <div class="column1">List of substations &middot; <span class="match-span"> {{this.dsoSubstations.length}} substations</span>
              </div>
              <div class="column2">
                <v-select
                  v-model="selectedDSOSubs"
                  class="filter-input2" 
                  hide-details
                  color="#58c26d"
                  @change="changeDSOSubs()"
                  :items="dsoSubs"
                  item-text="subName"
                  item-value="subCode"
                  dense
                  outlined
                ></v-select>
              </div>
            </div>
          </div>
    
          <!-- <div class="table-wrapper thead" v-if="!loadedDSO"> -->
          <div class="table-wrapper thead">
            <thead>
              <tr>
                <th class="resource-id">No.</th>
                <th class="resource-name">Name</th>
                <th>Peak Load</th>
                <th>Status</th>
                <th class="resource-coord">Latitude</th>
                <th class="resource-coord">Longitude</th>
              </tr>
            </thead>
          </div>
          <!-- <div class="table-wrapper t-bottom" id="offersTable" v-if="!loadedDSO"> -->
          <div class="table-wrapper t-bottom" id="offersTable">
            <tbody :class="{ active: index == currentRequestIndex }"
                    v-for="(dsoSubstation, index) in dsoSubstations"
                    :key="index"
                    @click="setActiveRequest(dsoSubstation, index)">
                <tr>
                    <td class="resource-id">{{ index+1 }}</td>
                    <td class="resource-name">{{ dsoSubstation.properties.Substation }}</td>
                    <td>{{ dsoSubstation.properties["Peak Load"] }}</td>
                    <td>Connected</td>
                    <td class="resource-coord">{{ dsoSubstation.geometry.coordinates[0] }}</td>
                    <td class="resource-coord">{{ dsoSubstation.geometry.coordinates[1] }}</td>
                </tr>
            </tbody>
          </div>

          <br>
          <!-- <div class="match-header" v-if="!loadedDSO"> -->
          <div class="match-header">
            List of lines &middot;<span class="match-span">
              {{this.list_DSO_Lines.length}} lines</span
            >
          </div>
          <!-- <div class="table-wrapper thead" v-if="!loadedDSO"> -->
          <div class="table-wrapper thead">
            <thead>
              <tr>
                <th class="resource-id">No.</th>
                <th class="resource-name">Name</th>
                <th>From</th>
                <th>To</th>
                <th>Operating</th>
                <th>Status</th>
                <th>Impedance (Ohm)</th>
                <th>Distance (km)</th>
              </tr>
            </thead>
          </div>
          <!-- <div class="table-wrapper t-bottom" id="offersTable" v-if="!loadedDSO"> -->
          <div class="table-wrapper t-bottom" id="offersTable">
            <tbody>
              <tr :class="{ active: index == currentMatchingIndex }"
                  v-for="(list_DSO_Line, index) in list_DSO_Lines"
                  :key="index"
                  @click="setActiveRequest(list_DSO_Line, index)">
                <td class="resource-id">{{ list_DSO_Line.properties.id }}</td>
                <td class="resource-name">{{ list_DSO_Line.properties.name }}</td>
                <td>{{ list_DSO_Line.properties.from }}</td>
                <td>{{ list_DSO_Line.properties.to }}</td>
                <td>{{ list_DSO_Line.properties.operating }}</td>
                <td>{{ list_DSO_Line.properties.status }}</td>
                <td>{{ list_DSO_Line.properties.impedance }}</td>
                <td>{{ list_DSO_Line.properties.distance }}</td>
              </tr>
            </tbody>
          </div>

        </div> 
      </div>
    </div>
  </div>
</template>

<script>

import { turkey_400kV_Substations } from "../../maps/data";
import { turkey_400kV_Lines } from "../../maps/data";
import { turkey_154kV_Substations } from "../../maps/data";
import { turkey_154kV_Lines } from "../../maps/data";
import { turkey_20kV_Substations } from "../../maps/data";
import { turkey_20kV_Lines } from "../../maps/data";
import { turkey_10kV_Substations } from "../../maps/data";
import { turkey_10kV_Lines } from "../../maps/data";

export default {
  name: "network-auto",

  props: ["currentIndex"],

  data() {
    return {

      list_400kV_Substations: turkey_400kV_Substations.features,
      list_154kV_Substations: turkey_154kV_Substations.features,
      list_HV_Lines: turkey_400kV_Lines.features,
      list_DSO_Lines: turkey_400kV_Lines.features,
      list_State_Lines: turkey_20kV_Lines.features,

      selectedKV: "All",
      selectedDSOSubs: "400 kV",
      selectedStateSubs: "20 kV",
      
      loadedDSO: true,
      loadedState: true,

      substations: turkey_400kV_Substations.features,
      
      dsoSubstations: turkey_400kV_Substations.features,
      stateSubstations: turkey_20kV_Substations.features,

      dsoSubs: [
        {
          subCode: "400 kV",
          subName: "400 kV",
        },
        {
          subCode: "154 kV",
          subName: "154 kV",
        },
      ],

      stateSubs: [
        {
          subCode: "20 kV",
          subName: "20 kV",
        },
        {
          subCode: "10 kV",
          subName: "10 kV",
        },
      ],

      kVs: [
        {
          kVCode: "All",
          kVName: "All",
        },
        {
          kVCode: "400kV SUBSTATIONS",
          kVName: "400kV SUBSTATIONS",
        },
        {
          kVCode: "154kV SUBSTATIONS",
          kVName: "154kV SUBSTATIONS",
        }
      ],

      requests: [],
      totalRequest: null,
      currentRequest: null,
      currentRequestIndex: -1,

      offers: [],
      totalOffer: null,
      currentOffer: null,
      currentOfferIndex: -1,

      matchings: [],
      totalMatching: null,
      currentMatching: null,
      currentMatchingIndex: -1,

      myRequests: [],
      selectedRequestIDs: [],
      selectedRequests: [],

      bread: [
        {
          text: "Network",
          disabled: false,
          // href: "/dashboardAdmin",
        },
        {
          text: "Substation & Lines",
          disabled: false,
        },
      ],

    };
  },

  methods: {

    changeDSOSubs() {
      console.log("Selected dsoSubs: ", this.selectedDSOSubs)
      if (this.selectedDSOSubs == "400 kV") {
        this.dsoSubstations = turkey_400kV_Substations.features;
        this.list_DSO_Lines = turkey_400kV_Lines.features;
      } else {
        this.dsoSubstations = turkey_154kV_Substations.features;
        this.list_DSO_Lines = turkey_154kV_Lines.features;
      }
      console.log("DSO Substations: ", this.dsoSubstations)
    },

    changeStateSubs() {
      console.log("Selected stateSubs: ", this.selectedStateSubs)
      if (this.selectedStateSubs == "20 kV") {
        this.stateSubstations = turkey_20kV_Substations.features;
        this.list_State_Lines = turkey_20kV_Lines.features;
      } else {
        this.stateSubstations = turkey_10kV_Substations.features;
        this.list_State_Lines = turkey_10kV_Lines.features;
      }
      console.log("State Substations: ", this.stateSubstations)
    },

    changeKV() {
      console.log("Selected kV: ", this.selectedKV)
      
      switch(this.selectedKV) {
        case "All":
          this.$parent.addSubstations();
          break;
        case "400kV SUBSTATIONS":
          this.$parent.add_400kV_Substations();
          break;
        case "220kV SUBSTATIONS":
          this.$parent.add_154kV_Substations();
          break;
        default:
          //this.$parent.buildMap(this.$store.state.auth.user.countryCode);
          this.$parent.buildMap("TR");
      }

      console.log("Substations: ", this.substations)

    },

    offerRequest() {
      this.Apps.offerRequest();
    },
    
    setActiveRequest(request, index) {
      this.currentRequest = request;
      this.currentRequestIndex = index;
      //this.filterOffers();
    },

    setActiveOffer(offer, index) {
      this.currentOffer = offer;
      this.currentOfferIndex = index;
    },

    setActiveMatching(matching, index) {
      this.currentMatching = matching;
      this.currentMatchingIndex = index;
    },
    
  },

  updated() {
    // Fired every second, should always be true
    this.substations;
    this.dsoSubstations;
    this.stateSubstations;
    this.list_DSO_Lines;
    this.list_State_Lines;
    this.loadedDSO;
    this.loadedState;
  },

  computed: {

  },

  created() {

  },

  mounted: function () {
   
    this.$store.state.auth.user;
   
    this.$nextTick(function () {
      
    });
    
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";

.offer-container {
  min-height: calc(100vh - 50px);
  max-height: calc(100vh - 50px);
  background: #f5fcff;
  width: 750px;
  padding: 20px 30px;
  position: relative;
  overflow-y: auto
}

.offer-inner-container {
  padding: 40px;
}

.offer-table-wrapper {
  box-shadow: 0 4px 6px 0 hsla(0, 0, 0, 0.2);
}

.top-offer-table-bar {
  background: #f9fafe;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f3fb;
}

.offer-search-wrapper {
  display: flex;
  align-items: center;
  width: 30%;
  max-width: 300px;
}

.offer-input {
  display: inline-block;
  font-size: 0.9rem;
  color: $black;
  line-height: 1.3;
  padding: 0.6em 0.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0 10px 0 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.1em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

.offer-input:focus,
.offer-search-button:focus {
  outline: none;
  border: 1px solid #6680a0;
  box-shadow: 0 0 5px #c8d2da;
}

.offer-add-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #bfecb5;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  margin-right: 10px;
}

.offer-remove-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #f8736b;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
}

.table-wrapper {
  max-height: 160px;
  width: 700px;
  max-width: 700px;
  overflow-y: scroll;
  // -webkit-box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
  // -moz-box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
  // box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
}

.table-wrapper thead{
  width: 100%;
  display: block;
  border-bottom: 1px solid #f4f7fa;
  cursor: pointer
}

.table-wrapper tbody, 
.table-wrapper tr {
  width: 100%;
  display: block;
  border-bottom: 1px solid #f4f7fa;
  cursor: pointer
}

.table-wrapper tr:hover {
  background: #f4f7fa;
}

.table-wrapper td {
  padding: 10px;
  color: #4a4a4a;
  font-size: 14px;
  display: inline-block;
  width: 12.5%;
}

.table-wrapper th {
  
  background: #253858;
  padding: 10px;
  color: #f7f7f7;
  font-size: 14px;
  display: inline-block;
  width: 12.5%;
}

.table-wrapper thead {
  background: #f7f7f7
}

.resource-id {
  width: 5% !important;
}

.resource-name {
  width: 30% !important;
}

.resource-coord {
  width: 20% !important;
}

.resource-action {
  text-align: center;
}

.offer-table {
  background: #fff;
  width: 100%;
  position: relative;
  border-collapse: collapse;
}

.offer-table th {
  position: sticky;
  top: 0;
  color: #4a4a4a;
  font-size: 16px;
  //text-transform: uppercase;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
}

.offer-table td {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 600px;
  padding: 12px 10px;
  border-spacing: 0;
  margin: 0;
  text-align: left;
}

.offer-table tr {
  cursor: pointer;
}

.offer-table tr:hover {
  background: hsla(132, 46, 55, 0.2);
}

.active {
  background: hsla(132, 46, 55, 0.5);
}

.active:hover {
  background: hsla(132, 46, 55, 0.5) !important;
}

.table-button {
  background: none;
  border: none;
  padding: 0 5px;
  color: #007bff;
}

.table-button:hover {
  text-decoration: underline;
  color: #007bff;
}

.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.table-info-wrapper {
  margin-bottom: 10px;
  margin-top: 20px;
  background-color: #fff;
  padding: 20px 20px 20px 20px;
  border-radius: 10px;
  overflow: hidden;
  -webkit-box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
  box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
}
.popup-top {
  display: flex;
  justify-content: space-between;
}
.popup-flex {
  display: flex;
  justify-content: space-between;
}

.table-popup-left,
.table-popup-top-left {
  width: 60%;
  position: relative;
}
.table-popup-right,
.table-popup-top-right {
  width: 40%;
  position: relative;
}
.table-tag {
  padding: 5px 20px;
  background-color: #253858;
  color: #fff;
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  margin-right: -20px;
}
.popup-title {
  font-weight: 700;
  font-size: 1.3rem;
  color: #253858;
}
.popup-label {
  color: #aeacad;
  font-size: 0.9rem;
  margin-top: 10px;
}
.popup-info {
  font-size: 0.9rem;
  color: #253858;
}

.fa-clock,
.fa-map-marker-alt {
  color: #b4b2b2;
}

.table-icon .fa-clock {
  margin-left: 10px;
}

.popup-price {
  font-size: 1rem;
  font-weight: 700;
  color: #253858;
}
.table-button {
  background-color: #58c26d;
  color: #fff;
  border: none;
  margin-top: 20px;
  padding: 8px 40px;
  border-radius: 5px;
  cursor: pointer;
}

.table-button:hover {
  background-color: hsla(132, 46, 55, 0.8);
  color: #fff;
  text-decoration: none;
}
.table-icon {
  font-size: 0.8em;
}
.table-middle {
  padding-bottom: 5px;
  border-bottom: 1px solid #253858;
}

.matching-button-wrapper {
  display: flex;
  align-items: center;
  margin: 20px 0 30px 0;
}

.bottom-button-wrapper {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-margin {
  margin-bottom: 30px;
}

.match-header {
  font-size: 20px;
  color: #3f516d;
  margin-bottom: 10px;
}

.match-span {
  font-size: 14px;
  color: #a3a3a4;
}


.column1 {
  width: 70%;
}

.column2 {
  width: 30%;
}

.legend {
  margin-left: 5px;
  margin-top: 5px;
}

.key-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.label-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.color {
    height: 30px;
    width: 30px;
    border: 1px solid $black;
    border-radius: 50px;
}

.label-container label {
    color: $black;
    margin-top: 10px;
    font-size: .9em;
}

.red {
    background: #f7746c
}

.yellow {
    background: #f6db6a;
}

.green {
    background: #bfecb5;
}

.loadMarker {
  display: block;
  border: none;
  width: 30px;
  height: 47px;
  background-image: url("../../img/loadMarker.png");
  background-size: contain;
  background-position: center;
  cursor: pointer;
  padding: 0;
  z-index: 1001;
}

.evMarker {
  display: block;
  border: none;
  width: 30px;
  height: 47px;
  background-image: url("../../img/evMarker.png");
  background-size: contain;
  background-position: center;
  cursor: pointer;
  padding: 0;
  z-index: 1001;
}

.generationMarker {
  display: block;
  border: none;
  width: 30px;
  height: 47px;
  background-image: url("../../img/resMarker.png");
  background-size: contain;
  background-position: center;
  cursor: pointer;
  padding: 0;
  z-index: 1001;
}

</style>
